import { render, staticRenderFns } from "./CommandPalette.vue?vue&type=template&id=fb924386"
import script from "./CommandPalette.vue?vue&type=script&lang=js"
export * from "./CommandPalette.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports